export default function ProductCreateController(
  $scope,
  $location,
  $state,
  productService,
  packagesService,
  gettextCatalog,
) {
  'ngInject';

  $scope.loading = true;
  //bool for showing modules dropdown if modules exist for currently selected package
  $scope.hasPkgModules = false;
  // ceate an array to hold the modules selected in the dropdown list
  $scope.selectedModules = [];
  //container to hold the modules from the selected package in the dropdown
  $scope.selectedPackageModules = [];
  //cup other containers to hold base packages and modules
  $scope.packages = []; //holds any package containing a tag ('base')
  $scope.modules = []; //holds any package containing a tag ('module')
  //build out the product model
  $scope.product = {
    name: '',
    metadata: {},
    package: {
      modules: [],
    },
    modules: [],
    tags: [],
  };
  $scope.templateNames = {};
  $scope.selectedPackage = null;

  $scope.addModuleToProduct = function (module, selectedModules) {
    $scope.selectedModules.push(module);
  };

  $scope.removeModuleFromProduct = function (module, selectedModules) {
    var idx = $scope.selectedModules.indexOf(module);
    $scope.selectedModules.splice(idx, 1);
  };

  /*************************************************************/

  var init = function () {
    productService
      .getAllProductsNames()
      .then(function (names) {
        $scope.templateNames = names;
      })
      .catch(() => {});
    packagesService.getAllPackages().then(
      function (response) {
        $scope.packageErrorFlag = false;
        $scope.packages = new Array();
        for (var i = 0; i < response.data.length; i++) {
          var pkg = response.data[i];
          if (!pkg.inactive) {
            if (pkg.tags) {
              if (pkg.isModule) {
                $scope.modules.push(pkg);
                continue;
              }
            }
            $scope.packages.push(pkg);
          }
        }
      },
      function (error) {
        $scope.packages = new Array();
        $scope.modules = new Array();
        var errorMsg = gettextCatalog.getString('Error retrieving packages from the i3 API ');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.packageErrorFlag = true;
        $scope.packageErrorText = errorMsg;
      },
    );

    $scope.loading = false;
  };

  init();

  $scope.changeSelectedPackage = function (selectedPackage) {
    $scope.product.package = selectedPackage;
    $scope.selectedItemChanged();
    window.dataLayer.push({
      event: 'newTemplatePackageChanged',
    });
  };

  //selectedItemChanged() will traverse the modules[] and the packages.modules[], compare the modules list in
  //both result sets and determine wether or not the selectedPackage has compatible modules to display to the user.
  $scope.selectedItemChanged = function () {
    $scope.selectedPackageModules = [];
    $scope.selectedModules = [];
    if ($scope.product.package.modules.length >= 1) {
      angular.forEach($scope.modules, function (gm) {
        angular.forEach($scope.product.package.modules, function (pm) {
          if (gm.id === pm) {
            $scope.selectedPackageModules.push(gm);
          }
        });
      });
    }
    //set hide or show the modules dropdown
    if ($scope.selectedPackageModules.length > 0) {
      $scope.hasModulespkg = true;
    } else {
      //We need to remove the existing values from the model and selectedPackageModules when hasModules is false.
      $scope.hasModulespkg = false;
      $scope.selectedModules = [];
      $scope.selectedPackageModules = [];
    }
  };

  // add or update a product
  $scope.submitproductForm = function () {
    if (
      $scope.productForm.$invalid ||
      $scope.packageErrorFlag ||
      $scope.gettingPackage ||
      $scope.loading
    ) {
      return;
    }
    $scope.errorFlag = false;

    //get the hardware from modules, because of the multiselect we use we cannot return the entire object
    //instead only the id is return so we have to go through the selected and compare them to all the modules
    if ($scope.selectedModules.length > 0) {
      for (var i = 0; i < $scope.modules.length; i++) {
        for (var j = 0; j < $scope.selectedModules.length; j++) {
          if ($scope.selectedModules[j].id === $scope.modules[i].id) {
            $scope.product.modules.push($scope.modules[i]);
          } //inner if .
        } //inner for
      } //outer for
    } //out if

    $scope.loading = true;
    productService
      .postNewProduct($scope.product)
      .then(
        function (response) {
          //If successfull go to the details page for this product
          $state.go('admin.products-edit', {
            id: response.data.id,
          });
        },
        function (error) {
          //if failed... show an error message
          var errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving package information.',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorFlag = true;
          $scope.errorText = errorMsg;
        },
      )
      .finally(function (result) {
        $scope.loading = false;
      });
  }; // end submitproductForm

  $scope.nameChanged = function () {
    $scope.productForm.prodname.exists = !!$scope.templateNames[$scope.product.name.toLowerCase()];
    window.dataLayer.push({
      event: 'newTemplateNameChanged',
    });
  };

  $scope.makeChanged = function () {
    window.dataLayer.push({
      event: 'newTemplateMakeChanged',
    });
  };

  $scope.modelChanged = function () {
    window.dataLayer.push({
      event: 'newTemplateModelChanged',
    });
  };
}
